<div class="sidebar">
    <!--
	<app-sidebar-header [title]="bookAwardFlights ? ('voucherPromocodeSidebar.title.haveAPromocode' | ibeadmin | async) :  ('voucherPromocodeSidebar.title.haveAGift' | ibeadmin | async)">
	</app-sidebar-header>
	-->
    <app-sidebar-header [title]="'voucherPromocodeSidebar.title.haveAGift' | ibeadmin | async">
    </app-sidebar-header>

    <div class="sidebar__body sl--scrollable" #sidebar__body>

        <div class="voucher-or-promocode">

            <div class="voucher-or-promocode__content">
                <p>
                    <!-- {{ bookAwardFlights ? ('voucherPromocodeSidebar.text.redeemYourPromocode' | ibeadmin | async) : ('voucherPromocodeSidebar.text.redeemPromocodeOrVoucher' | ibeadmin | async) }} -->
                    {{ 'voucherPromocodeSidebar.text.redeemPromocodeOrVoucher' | ibeadmin | async }}
                </p>
                <a [attr.aria-label]="'voucherPromocodeSidebar.aria.readVouchers'  | ibeadmin | async" class="link link--external" (click)="INDRA_redirectToUrl('externalURLs.voucherTermsUrl')" href="javascript:;" role="button">
                    <!-- {{ bookAwardFlights ? ('voucherPromocodeSidebar.text.termsAndConditions' | ibeadmin | async) : ('voucherPromocodeSidebar.text.vouchersPromocodesTerms' | ibeadmin | async) }} -->
                    {{ 'voucherPromocodeSidebar.text.vouchersPromocodesTerms' | ibeadmin | async }}
                </a>
            </div>

            <div class="voucher-or-promocode__vouchers" [class.disabled-div]="triggerHppRedFlag">

                <div class="divider"></div>

                <ng-container *ngIf="hasMilesDiscount">
                    <app-notification [style]="'alert'" [title]="'voucherPromocodeSidebar.title.sorryItsNotPossible' | ibeadmin | async" [icon]="'icons.svg#miles_and_go--manage_miles'">
                        <div message>
                            <span>{{'voucherPromocodeSidebar.text.youCanUseEither' | ibeadmin | async}} 
							<span class="bold">{{'voucherPromocodeSidebar.text.voucherPromocodes' | ibeadmin | async}}</span> {{'voucherPromocodeSidebar.text.or' | ibeadmin | async}}
                            <span class="bold">{{'voucherPromocodeSidebar.text.miles' | ibeadmin | async}}</span>. {{'voucherPromocodeSidebar.text.please' | ibeadmin | async}}
                            <a [attr.aria-label]="'voucherPromocodeSidebar.aria.removeMiles' | ibeadmin | async" class="link link--dark" href="javascript:;" role="button" (click)="INDRA_removeMiles()">{{'voucherPromocodeSidebar.text.removeMiles' | ibeadmin | async}}</a>                            {{'voucherPromocodeSidebar.text.ifYouWantToAdd' | ibeadmin | async}}
                            </span>
                        </div>
                    </app-notification>
                </ng-container>

                <app-notification (closeNotif)="INDRA_close($event)" *ngIf="showError" [style]="'error'" [icon]="'icons.svg#airport--delays'" [close]="true" [title]="''">
                    <div message>
                        <span>{{ 'voucherPromocodeSidebar.text.termsAndConditions' | ibeadmin | async }}</span> <br />
                    </div>
                </app-notification>
                <div *ngIf="discounts.length">
                    <div class="voucher" *ngFor="let discount of discounts; let i = index">

                        <div class="voucher__content">
                            <app-svg aria-hidden="true" [alt]="'voucherPromocodeSidebar.alt.discountIcon' | ibeadmin | async" class="voucher__content_icon" svg="sprite.svg#status--discount">
                            </app-svg>
                            <div class="voucher__content-text">
                                <h3 class="title-h3">
                                    {{ 'voucherPromocodeSidebar.label.discountApplied' | ibeadmin | async }} {{ discount.code }}
                                </h3>
                                <!-- with flight selected -->
                                <ng-container *ngIf="booked_trip && booked_trip.flights && booked_trip.flights.length > 0; else hasNoBookedTrip">
                                    <p *ngIf="discount.type === 'voucher'">
                                        {{ 'voucherPromocodeSidebar.text.voucherApplied' | ibeadmin | async }}
                                        <span class="bold">
										{{ discount.amount }} {{ discount.currencyCode }}
									</span> {{ 'voucherPromocodeSidebar.text.inThisBooking' | ibeadmin | async }}
                                        <!-- TODO implement this
									{{ 'voucherPromocodeSidebar.text.thereAre' | ibeadmin | async }} {{ voucherBalance }} {{ 'voucherPromocodeSidebar.text.remainingBalanceVoucher' | ibeadmin | async}}
									<ng-container *ngIf="voucherBalance > 0">
										{{ 'voucherPromocodeSidebar.text.useInAnotherBooking' | ibeadmin | async}}
									</ng-container>
									-->
                                    </p>
                                    <p *ngIf="discount.type === 'promocode'">
                                        <ng-container *ngIf="discount.currencyCode === 'M'; else withFlightsCash">
                                            {{ 'voucherPromocodeSidebar.text.youArePaying' | ibeadmin | async }}
                                        </ng-container>
                                        <ng-template #withFlightsCash>
                                            {{ 'voucherPromocodeSidebar.text.youAreGetting' | ibeadmin | async }}
                                        </ng-template>
                                        <span class="bold" *ngIf="discount.amountType === FIXED_DISCOUNT">
										{{ discount.amount }} {{ discount.currencyCode }}
									</span>
                                        <span class="bold" *ngIf="discount.amountType === PERCENTAGE_DISCOUNT">
										<ng-container *ngIf="discount.currencyCode === 'M'; else withFlightsActualDiscountAmount">
											{{ INDRA_displayActualDiscountAmount(discount) }}
										</ng-container>
										<ng-template #withFlightsActualDiscountAmount>
											{{ INDRA_displayActualDiscountAmount(discount) | indracurrency: discount.currencyCode }}
										</ng-template>
									</span>
                                        <span class="bold">
										<ng-container *ngIf="discount.currencyCode === 'M'; else withFlightsDiscountSuffix">
											{{ 'voucherPromocodeSidebar.label.less' | ibeadmin | async }} 
										</ng-container>
										<ng-template #withFlightsDiscountSuffix>
											{{ 'voucherPromocodeSidebar.text.discount' | ibeadmin | async }} 
										</ng-template>
									</span> {{ 'voucherPromocodeSidebar.text.inThisBooking' | ibeadmin | async }}
                                    </p>
                                </ng-container>
                                <!-- without flight selected -->
                                <ng-template #hasNoBookedTrip>
                                    <p *ngIf="discount.type === 'voucher'">
                                        {{ 'voucherPromocodeSidebar.text.voucherApplied' | ibeadmin | async }}
                                        <span class="bold">
										{{ discount.amount }} {{ discount.currencyCode }}
									</span> {{ 'voucherPromocodeSidebar.text.selectFlights' | ibeadmin | async }}
                                    </p>
                                    <p *ngIf="discount.type === 'promocode'">
                                        <ng-container *ngIf="discount.currencyCode === 'M'; else noFlightsCash">
                                            {{ 'voucherPromocodeSidebar.text.youArePaying' | ibeadmin | async }}
                                        </ng-container>
                                        <ng-template #noFlightsCash>
                                            {{ 'voucherPromocodeSidebar.text.youAreGetting' | ibeadmin | async }}
                                        </ng-template>
                                        <ng-container *ngIf="discount.amountType === FIXED_DISCOUNT">
                                            <span class="bold">
											{{ discount.amount }} {{ discount.currencyCode }} 
											<ng-container *ngIf="discount.currencyCode === 'M'; else noFlightsDiscountSuffix">
												{{ 'voucherPromocodeSidebar.label.less' | ibeadmin | async }} 
											</ng-container>
											<ng-template #noFlightsDiscountSuffix>
												{{ 'voucherPromocodeSidebar.text.discount' | ibeadmin | async }} 
											</ng-template> 
										</span> {{ 'voucherPromocodeSidebar.text.inThisBooking' | ibeadmin | async }}
                                        </ng-container>
                                        <ng-container *ngIf="discount.amountType === PERCENTAGE_DISCOUNT">
                                            <span class="bold" *ngIf="discount.amountType === PERCENTAGE_DISCOUNT">
											{{ discount.amount + '%'}} {{ 'voucherPromocodeSidebar.text.discount' | ibeadmin | async }} 
										</span> {{ 'voucherPromocodeSidebar.text.selectFlights' | ibeadmin | async }}
                                        </ng-container>
                                    </p>
                                </ng-template>
                            </div>
                        </div>
                        <app-svg [title]="'voucherPromocodeSidebar.title.removeVoucher' | ibeadmin | async" [attr.aria-label]="'voucherPromocodeSidebar.aria.removeFastTrack' | ibeadmin | async" [ngClass]="['remove-voucher']" svg="icons.svg#general--close" (click)="INDRA_removePromocode(discount, i )"
                            [alt]="'voucherPromocodeSidebar.alt.removeIcon' | ibeadmin | async">
                        </app-svg>
                        <app-loading-circle class="voucher-or-promocode__loading" *ngIf="loading" aria-live="polite">
                        </app-loading-circle>
                    </div>
                </div>

                <form class="voucher-or-promocode__form sidebar__form" [formGroup]="formAdd" *ngIf="showFormAdd && discounts.length < 3">
                    <div class="form-field--row grid no-padding">

                        <div class="form-field col-8 col-tl-7 col-tp-7 col-p-12">
                            <label class="label" for="promocode-or-voucher">
							<!-- {{ bookAwardFlights ? ('voucherPromocodeSidebar.label.promocode' | ibeadmin | async) : ('voucherPromocodeSidebar.label.promocodeOrVoucherNumber' | ibeadmin | async) }} -->
							{{ 'voucherPromocodeSidebar.label.promocodeOrVoucherNumber' | ibeadmin | async }}
						</label>
                            <input [attr.aria-label]="'voucherPromocodeSidebar.label.insertPromoVoucher' | ibeadmin | async" [attr.disabled]="validatingVoucherPromocode ? true : null" class="input-text" formControlName="promocode" id="promocode-or-voucher" [value]="inputCode" (input)="INDRA_valuechange($event.target.value)"
                            />
                            <span aria-live="polite" class="input-error" role="alert" *ngIf="INDRA_hasErrors">
							{{ INDRA_hasErrors }}
						</span>
                        </div>

                        <div class="form-field col-8 col-tl-7 col-tp-7 col-p-12" *ngIf="isVoucher">
                            <label class="label" for="promocode-or-voucher">{{ 'voucherPromocodeSidebar.label.emailAddressVoucherReceived' | ibeadmin | async }}</label>
                            <input [attr.disabled]="validatingVoucherPromocode ? true : null" name="email" id="promocode-or-voucher-email" formControlName="promocodeemail" placeholder="{{'voucherPromocodeSidebar.placeholder.insertVoucherEmail' | ibeadmin | async}}" class="input-text"
                            />
                        </div>

                        <!-- <div class="form-field col-8 col-tl-7 col-tp-7 col-p-12" *ngIf="isVoucher">
						<label class="label" for="promocode-or-voucher">Email address were the voucher was recived</label>
						<input [attr.disabled]="validatingVoucherPromocode ? true : null" name="email" id="promocode-or-voucher-email" placeholder="Insert voucher email" class="input-text"/>
					</div> -->

                        <div class="form-field col-8 col-tl-7 col-tp-7 col-p-12" *ngIf="isVoucher && showVoucherPin">
                            <input [attr.disabled]="validatingVoucherPromocode ? true : null" id="promocode-or-voucher-pin" formControlName="promocodepin" placeholder="{{'voucherPromocodeSidebar.placeholder.insertVoucherPin' | ibeadmin | async}}" class="input-text" />
                            <span class="input-error" role="alert" aria-live="polite" *ngIf="INDRA_hasPinErrors; else pinInfo">
                                {{ INDRA_hasPinErrors }}
                            </span>
                            <ng-template #pinInfo>
                                <span class="voucher-or-promocode__content_description">
                                    {{ 'voucherPromocodeSidebar.text.weSentYouAPin' | ibeadmin | async }}
                                    {{ 'voucherPromocodeSidebar.text.pleaseCheckYourInbox' | ibeadmin | async }}
                                </span>
                            </ng-template>
                        </div>

                        <div class="form-field col-4 col-tp-5 col-tp-5 col-p-12">
                            <div class="voucher-or-promocode__actions">
                                <button [attr.disabled]="validatingVoucherPromocode ? true : null" class="button" (click)="INDRA_addVoucher()" [attr.aria-label]="'voucherPromocodeSidebar.aria.useDiscount' | ibeadmin | async">
								{{ 'voucherPromocodeSidebar.label.getDiscount' | ibeadmin | async }}
							</button>
                                <app-loading-circle class="voucher-or-promocode__loading" *ngIf="validatingVoucherPromocode" aria-live="polite" [attr.aria-label]="'voucherPromocodeSidebar.aria.validatingVoucherPromocode' | ibeadmin | async">
                                </app-loading-circle>
                            </div>
                        </div>

                    </div>
                </form>

                <!--
			<a class="link add-another-voucher" 
				[attr.aria-label]="'voucherPromocodeSidebar.aria.addAnotherVoucher' | ibeadmin | async" 
				(click)="INDRA_addAnotherVoucher()" 
				*ngIf="!bookAwardFlights && discounts.length < 3 && !showFormAdd" 
				href="javascript:;" 
				role="button">
				{{ 'voucherPromocodeSidebar.label.addAnotherVoucher' | ibeadmin | async }}
			</a>
			<div class="voucher-or-promocode__message-wrapper" *ngIf="!bookAwardFlights && discounts.length >= 3">
				<app-svg class="voucher-or-promocode__icon" 
					svg="icons.svg#general--information" 
					aria-hidden="true" 
					[alt]="'voucherPromocodeSidebar.alt.informationIcon' | ibeadmin | async">
				</app-svg>
				<span class="voucher-or-promocode__message">
					{{ 'voucherPromocodeSidebar.label.cantAddVouchers' | ibeadmin | async }}
				</span>
			</div>
			<div class="voucher-or-promocode__message-wrapper" *ngIf="bookAwardFlights && discounts.length >= 1">
				<app-svg class="voucher-or-promocode__icon" 
					svg="icons.svg#general--information" 
					aria-hidden="true" 
					[alt]="'voucherPromocodeSidebar.alt.informationIcon' | ibeadmin | async">
				</app-svg>
				<span class="voucher-or-promocode__message">
					{{ 'voucherPromocodeSidebar.label.cantAddVouchers' | ibeadmin | async }}
				</span>
			</div>
			-->

                <a class="link add-another-voucher" [attr.aria-label]="'voucherPromocodeSidebar.aria.addAnotherVoucher' | ibeadmin | async" (click)="INDRA_addAnotherVoucher()" *ngIf="discounts.length < 3 && !showFormAdd && !hasMilesDiscount" href="javascript:;" role="button">
				{{ 'voucherPromocodeSidebar.label.addAnotherVoucher' | ibeadmin | async }}
			</a>
                <div class="voucher-or-promocode__message-wrapper" *ngIf="discounts.length >= 3">
                    <app-svg class="voucher-or-promocode__icon" svg="icons.svg#general--information" aria-hidden="true" [alt]="'voucherPromocodeSidebar.alt.informationIcon' | ibeadmin | async">
                    </app-svg>
                    <span class="voucher-or-promocode__message">
					{{ 'voucherPromocodeSidebar.label.cantAddVouchers' | ibeadmin | async }}
				</span>
                </div>

            </div>
        </div>

        <div class="sidebar-flight-text">
            <p>
                <a class="link extras-feature__link" [attr.aria-label]="'voucherPromocodeSidebar.label.closeDialog' | ibeadmin | async" (click)="INDRA_handleClose()" href="javascript:;" role="button">
					{{ 'voucherPromocodeSidebar.label.closeThisWindow' | ibeadmin | async }}
				</a>
            </p>
        </div>

    </div>

    <div #sidebar__footer class="sidebar__footer ">
    </div>

</div>